<template>
  <div class='ProdImg02' @click="Select" @mouseenter="toggleImg(true)" @mouseleave="toggleImg(false)">
    <div class="cont-img" v-if="data.img.length">
      <Transition>
        <img v-if="!show && data.img.length > 0" :src="api + data.img[0].img">
      </Transition>
      <Transition>
        <img v-if="show && data.img.length > 1" :src="api + data.img[1].img">
      </Transition>
    </div>
    <div class="cont-img-icon">
      <img-icon
      :options="{ width: '180px', height: '150px', color: '#CCCCCC', action: false }"
      v-if="!data.img.length"
      />
    </div>
    <div class="oferta" v-if="data.oferta > 0">
      <div style="width: 50%; text-align: left; color: #FFFFFF">Promoção</div>
      <div style="width: 50%; text-align: right; font-weight: bold;">R$ {{ data.oferta }}</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ImgIcon from '@/components/EnbPainel/Icons/ImgIcon'
import api from '@/mixins/api'
export default {
  name: 'ProdImg02',
  components: { ImgIcon },
  props: ['data'],
  mixins: [api],
  methods: {
    ...mapActions(['SetItem01']),
    Select () {
      this.SetItem01(this.data)
        .then( async () => {
          if(typeof this.$route.params.categ !== 'undefined') {
            this.$router.push(`/loja/${this.$route.params.categ}/${this.data.link}`)
          } else {
            this.$router.push(`/${this.data.link}`)
          }
        })
    },
    toggleImg (img) {
      if (img && this.data.img.length > 1) {
        this.show = true
      } else {
        this.show = false
      }
    }
  },
  data () {
    return {
      show: false
    }
  }
}
</script>

<style scoped>
.ProdImg02 {
  width: 100%;
  height: 230px;
  position: relative;
  cursor: pointer;
}

.cont-img-icon {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

img {
  width: 100%;
  height: 100%;
  margin-left: -50%;
  position: absolute;
}

.oferta {
  display: flex;
  position: absolute;
  bottom: 0;
  padding: 2%;
  width: 96%;
  background-color: rgb(11, 141, 109);
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
